import { useMemo } from "react"
import NumberFlow from "@number-flow/react"
import { useTranslation } from "react-i18next"
import { useMediaQuery, useTheme } from "@mui/material"
import Typography from "../global/Typography"
import { colors } from "../../services/config/colors"

interface StoryChipProps {
  current: number
  total: number
}

const StoryChip = ({ current, total }: StoryChipProps) => {
  const { i18n } = useTranslation()
  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"))

  // container size
  const containerSize = useMemo(
    () => ({
      width: matchesMD ? (current < 10 ? 58 : 64) : current < 10 ? 62 : 70,
      height: matchesMD ? 26 : 32,
    }),
    [matchesMD, current]
  )

  // label font size
  const fontSize = useMemo(() => (matchesMD ? 14 : 16), [matchesMD])

  return (
    <div
      style={{
        width: containerSize.width,
        height: containerSize.height,
        minHeight: containerSize.height,
        paddingInline: 0,
        transition: "150ms",
        borderRadius: 16,
        backgroundColor: colors.backgroundWhite,
        border: `3px solid ${colors.background}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography fontSize={fontSize} fontWeight={800} uppercase>
        <NumberFlow value={Math.floor(current)} locales={i18n.language} />/
        {total}
      </Typography>
    </div>
  )
}

export default StoryChip
